module.exports = __webpack_public_path__ + "themes/mf/img/prize-1.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-1.png
// module id = 86
// module chunks = 3